module.exports = __webpack_public_path__ + "f275c3ceb407b737994cba24cd92ee46.svg";